<nz-modal
  [nzVisible]="true"
  [nzTitle]="undefined"
  [nzFooter]="null"
  nzCentered
  nzWrapClassName="charger-connected__popup"
  nzWidth="fit-content">
  <ng-container *nzModalContent>
    <div class="charging-connected__wrapper">
      <img
        class="charging-connected__gif"
        src="assets/gifs/charging.gif"
        alt="charging gif" />
      <h4 class="charging-connected__title">Charging...</h4>
    </div>
  </ng-container>
</nz-modal>
